module.exports = "/assets/data/550750f612ccadecdf393706268542d6-LE67.data.json";